import * as React from "react";
import { WorkflowExpenseList } from 'src/components/common/ExpenseList/WorkflowExpenseList';
import { ExpenseStatusEnum } from 'src/services/Enum/ExpenseStatusEnum';
import { OpenModalExpenseCommentsButton } from 'src/components/common/ExpenseComments/Buttons/OpenModalExpenseCommentsButton/OpenModalExpenseCommentsButton';

export const RejectedExpensesPage = () => {
  const listStatus: ExpenseStatusEnum[] = [ExpenseStatusEnum.REJECTED];
  const cardTitle = "Solicitações rejeitadas";

  return <WorkflowExpenseList
    listStatus={listStatus}
    cardTitle={cardTitle}>
    <OpenModalExpenseCommentsButton />
  </WorkflowExpenseList>;
}



// WEBPACK FOOTER //
// ./src/pages/expenses/RejectedExpenses/RejectedExpenses.page.tsx